module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('el-menu', {
    staticClass: "theme-primary",
    attrs: {
      "default-active": _vm.$route.path,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": ("/projects/" + _vm.id + "/stats")
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.project.stats.data')) + "\n      ")]), _vm._v(" "), (_vm.project.has_form) ? _c('el-menu-item', {
    attrs: {
      "index": ("/projects/" + _vm.id + "/stats/form")
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.project.stats.form')) + "\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-view', {
    staticClass: "sub-stats"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40395350"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/stats/index.vue
// module id = 914
// module chunks = 3